import React from 'react';
import ReactDOM from 'react-dom/client';
import AppView from './views/app.view';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppView />);

// root.render(
//   <React.StrictMode>
//     <AppView />
//   </React.StrictMode>
// );
